module.exports = __webpack_public_path__ + "static/media/storeBanner1.ede820f6.png";